export const Types = {
  GET_TASK_REQUEST: 'GET_TASK_REQUEST',
  SET_CURRENT_TASK: 'SET_CURRENT_TASK',
  GET_TASK_SUCCESS: 'GET_TASK_SUCCESS',
  SELECT_TASK: 'SELECT_TASK',
  RESET_SELECTED_TASK: 'RESET_SELECTED_TASK',
  SET_INVOICE_FILTER_KEY: 'SET_INVOICE_FILTER_KEY',
  REMOVE_INVOICE_TASK_LIST: 'REMOVE_INVOICE_TASK_LIST',
  SET_PAGE_SIZE: 'SET_PAGE_SIZE',
  SET_USER_INFO: 'SET_USER_INFO', // Burada olmamalı,
  SET_TASKS_FILTER: "SET_TASKS_FILTER",
  GET_FILTERED_TASKS_REQUEST: "GET_TASKS_REQUEST",
  SET_FILTERED_TASKS: "SET_FILTERED_TASKS",
  SET_REQUEST_STATUS: "SET_REQUEST_STATUS",
  SET_FILTERED_TASKS_ERROR: "SET_FILTERED_TASKS_ERROR"
};

export const getTasksRequest = WorkOrderId => ({
  type: Types.GET_TASK_REQUEST,
  WorkOrderId
});

export const setTask = task => ({
  type: Types.SET_CURRENT_TASK,
  payload: { task }
});

export const getTasksSuccess = tasks => ({
  type: Types.GET_TASK_SUCCESS,
  payload: { tasks }
});

export const selectTask = task => ({
  type: Types.SELECT_TASK,
  payload: { task }
});

export const resetSelectedTask = task => ({
  type: Types.RESET_SELECTED_TASK,
  payload: { task }
});

export const setInoviceFilterKey = value => ({
  type: Types.SET_INVOICE_FILTER_KEY,
  payload: { value }
});

export const removeInvoiceTaskList = value => ({
  type: Types.REMOVE_INVOICE_TASK_LIST,
  payload: { value }
});

export const setPageSize = value => ({
  type: Types.SET_PAGE_SIZE,
  payload: { value }
});

export const setUserInfo = value => ({
  type: Types.SET_USER_INFO,
  payload: { value }
});

export const setTasksFilterModel = model => {
  return {
    type: Types.SET_TASKS_FILTER,
    payload: model
  }
}

export const getFilteredTasksRequest = (model) => ({
  type: Types.GET_FILTERED_TASKS_REQUEST,
  payload: model
});

export const setFilteredTasks = model => ({
  type: Types.SET_FILTERED_TASKS,
  payload: model
})

export const setRequestStatus = status => ({
  type: Types.SET_REQUEST_STATUS,
  payload: status
})

export const setFilteredTasksError = (failed = true) => ({
  type: Types.SET_FILTERED_TASKS_ERROR,
  payload: failed
})